import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AddUser from "../../components/Redes/Admin/AddUser";

import BeneficiosCRUD from "../../components/Redes/Admin/BeneficiosCRUD";
import AddBlog from "../../components/Redes/Admin/Blog";
import NavBarAdmin from "../../components/Redes/Admin/NavBarAdmin";
import FooterRedes from "../../components/Redes/FooterRedes";
import LoginAdminComponent from "../../components/Redes/LoginAdminComponent";
import UserContext from "../../components/user/UserContext";
import "../../styles/AdminDashboard.css";
import "../../styles/AdminModules.css";
import AfiliadosCRUD from "../../components/Redes/Admin/AfiliadosCRUD";
import RegistrarCanje from "../../components/Redes/Admin/RegistrarCanje";
import { getRedSummary } from "../../services/beneficiosService";
import { canManageAffiliates } from "../../components/Redes/Admin/affiliatePermissions";

// import AllMovimientos from "../../components/Redes/Admin/AllMovimientos";
// import AddProducto from "../../components/Redes/Admin/AddProducto";
// import AddSubRed from "../../components/Redes/Admin/AddSubRed";

// Pagina que se muestra en /admin
// muestra todas las finciones que puede tener un administrador
// 

const AdminDashBoard = () => {
    //cambiar user por admin
    const { user } = useContext(UserContext)
    const hasAffiliateAccess = canManageAffiliates(user)
    const [summary, setSummary] = useState(null)
    useEffect(() => {
        window.scrollTo(0, 0);
        if (user && hasAffiliateAccess) getRedSummary().then(setSummary).catch(() => setSummary({}))
        else setSummary(null)
    }, [user, hasAffiliateAccess])
    const value = field => summary ? (summary[field] ?? 0).toLocaleString("es-MX") : "..."
    return (
        <>
            {user === undefined ?
                <>
                    <LoginAdminComponent />
                </>
                :
                <>
                    <NavBarAdmin />
                    <main className="admin-dashboard">
                        <Container>
                            <div className="admin-heading">
                                <div>
                                    <p className="admin-kicker">PANEL DEL EQUIPO</p>
                                    <h1>Tablero de la Red</h1>
                                    <p>Gestiona la comunidad, sus aliados y los contenidos de la Fundación.</p>
                                </div>
                                <span className="admin-date">{new Date().toLocaleDateString("es-MX", { month: "long", year: "numeric" })}</span>
                            </div>
                            <section className="admin-stats" aria-label="Resumen de la red">
                                <div><strong>{value("afiliados")}</strong><span>Afiliados totales</span></div>
                                <div><strong>{value("nuevosMes")}</strong><span>Nuevos este mes</span></div>
                                <div><strong>{value("aliados")}</strong><span>Negocios aliados</span></div>
                                <div><strong>{value("canjes")}</strong><span>Beneficios usados</span></div>
                                <div><strong>${value("ahorro")}</strong><span>Ahorro estimado</span></div>
                            </section>
                            <section className="admin-tools">
                                <h2>Acciones de la red</h2>
                                <Row xs={1} md={3} className="g-3">
                                    <Col><a href="#beneficios-admin"><strong>Aliados</strong><span>Administra el directorio de beneficios</span></a></Col>
                                    <Col><a href="#canjes-admin"><strong>Canjes</strong><span>Registra beneficios usados por las familias</span></a></Col>
                                    <Col><a href="#contenido-admin"><strong>Contenido</strong><span>Actualiza el blog y los comunicados</span></a></Col>
                                </Row>
                            </section>
                        </Container>
                    </main>
                    {hasAffiliateAccess && <div id="beneficios-admin"><BeneficiosCRUD /></div>}
                    <div id="afiliados-admin"><AfiliadosCRUD /></div>
                    <div id="canjes-admin"><RegistrarCanje /></div>
                    <AddUser />
                    <div id="contenido-admin"><AddBlog /></div>
                    {/* <div id="movimientos-admin"><AllMovimientos /></div> */}
                    {/* <AddSubRed /> */}
                    {/* <AddProducto /> */}

                    <FooterRedes />
                </>
            }
        </>
    )
}
export default AdminDashBoard